import { memo } from 'react';
import cn from 'bem-cn';

import { Stack } from '../UI';
import { useStickyHeader } from '../../hooks';

import { FeedSort } from './FeedSort';
import { FeedHeaderProps } from './FeedHeader.types';
import './FeedHeader.scss';

const b = cn('feed-header');

export const FeedHeader = memo((props: FeedHeaderProps) => {
    const { anchorRef } = props;

    const { headerRef, shouldHide, isSticky } = useStickyHeader();

    return (
        <Stack ref={headerRef} direction="row" className={b({ hidden: shouldHide, sticky: isSticky })}>
            <h2 className={b('title', { mobile: true })}>Каталог</h2>
            <h2 className={b('title', { desktop: true })}>Каталог промптов</h2>
            <FeedSort anchorRef={anchorRef} />
        </Stack>
    );
});

FeedHeader.displayName = 'FeedHeader';
